import { Box, BoxProps } from "@chakra-ui/react";

interface CardProps extends BoxProps {
  children: any;
}

export const Card = ({ children, ...props }: CardProps) => {
  return (
    <Box
      border="1px solid gray"
      boxShadow={"md"}
      borderRadius={8}
      padding={2}
      {...props}
    >
      {children}
    </Box>
  );
};
